// ================================================================
// RunPanel — نمایش نتیجه‌ی اجرای scenario
// ================================================================

import './run-panel.css';
import { t } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';

let panelEl = null;

function ensurePanel() {
  if (panelEl) return panelEl;
  panelEl = document.createElement('div');
  panelEl.className = 'run-panel';
  document.body.appendChild(panelEl);
  return panelEl;
}

export function showLoading() {
  const el = ensurePanel();
  el.classList.add('run-panel--open');
  el.innerHTML = `
    <div class="run-panel-head">
      <div class="run-panel-title">
        <span class="run-spinner"></span>
        ${escapeHtml(t('bottombar.running'))}
      </div>
    </div>
  `;
}

export function showResult(result) {
  const el = ensurePanel();
  el.classList.add('run-panel--open');

  const ok = result.status === 'success';
  const headClass = ok ? 'run-head-ok' : 'run-head-warn';
  const headIcon = ok ? 'check_circle' : 'error';
  const headText = ok ? t('bottombar.runSuccess') : t('bottombar.runError');

  const nodesHtml = (result.results || []).map(renderNode).join('');

  el.innerHTML = `
    <div class="run-panel-head ${headClass}">
      <div class="run-panel-title">
        ${icon(headIcon, 20)}
        ${escapeHtml(headText)}
        <span class="run-panel-time">${result.durationMs} ms</span>
      </div>
      <button class="run-panel-close" data-action="close-run" title="${escapeHtml(t('bottombar.closePanel'))}">
        ${icon('close', 18)}
      </button>
    </div>
    <div class="run-panel-body">${nodesHtml}</div>
  `;

  el.querySelector('[data-action="close-run"]')?.addEventListener('click', hidePanel);
}

export function showError(message) {
  const el = ensurePanel();
  el.classList.add('run-panel--open');
  el.innerHTML = `
    <div class="run-panel-head run-head-warn">
      <div class="run-panel-title">
        ${icon('error', 20)}
        ${escapeHtml(t('bottombar.runError'))}
      </div>
      <button class="run-panel-close" data-action="close-run">${icon('close', 18)}</button>
    </div>
    <div class="run-panel-body">
      <div class="run-node run-node--error">
        <div class="run-node-msg">${escapeHtml(message)}</div>
      </div>
    </div>
  `;
  el.querySelector('[data-action="close-run"]')?.addEventListener('click', hidePanel);
}

export function hidePanel() {
  if (panelEl) panelEl.classList.remove('run-panel--open');
}

function renderNode(r) {
  const statusMap = {
    success: { cls: 'success', icon: 'check_circle' },
    skipped: { cls: 'skipped', icon: 'remove_circle' },
    error: { cls: 'error', icon: 'cancel' },
  };
  const s = statusMap[r.status] || statusMap.skipped;

  // اگه node ایمیل دیتا داره، لیست ایمیل‌ها رو نشون بده
  let emailsHtml = '';
  if (Array.isArray(r.data) && r.data.length) {
    emailsHtml = `
      <div class="run-emails">
        ${r.data.map((m) => `
          <div class="run-email">
            <div class="run-email-from">${escapeHtml(stripEmail(m.from))}</div>
            <div class="run-email-subject">${escapeHtml(m.subject || '(kein Betreff)')}</div>
            <div class="run-email-snippet">${escapeHtml((m.snippet || '').slice(0, 120))}</div>
          </div>
        `).join('')}
      </div>
    `;
  }

  return `
    <div class="run-node run-node--${s.cls}">
      <div class="run-node-head">
        <span class="run-node-status">${icon(s.icon, 18)}</span>
        <span class="run-node-type">${escapeHtml(r.type)}</span>
        <span class="run-node-msg">${escapeHtml(r.message)}</span>
      </div>
      ${emailsHtml}
    </div>
  `;
}

// "Make <info@make.com>" → "Make" یا اگه اسم نبود، خود ایمیل
function stripEmail(from) {
  if (!from) return '';
  const m = from.match(/^"?([^"<]+?)"?\s*</);
  return m ? m[1].trim() : from;
}
